import { createContext, useContext } from 'react';

import { EventInfo } from '../../../domain';

export interface EventHistoryQueryContextState {
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
  userEvents: EventInfo[];
  totalUserEventCount: number;
  campaignLabelsLookup: Record<number, string>;
}

export const EventHistoryQueryContext = createContext<EventHistoryQueryContextState>({
  isLoading: false,
  isError: false,
  userEvents: [],
  totalUserEventCount: 0,
  campaignLabelsLookup: {},
});

export const useEventHistoryQueryContext = () => useContext(EventHistoryQueryContext);
